import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { encryptRsakey } from '../../helpers/rsa-encryption'
import axios from "axios";
import moment from "moment";

// const environment = process.env.REACT_APP_API_MGW_HOST === 'https://api.cashless-qa.revenue.gov.bs' ? 'development' : 'production';
const format = (d) => {
  return moment(d).format("YYYY-MM-DD");
}

const headers = (contentType = 'application/json') => {
//   let user = sessionStorage.getItem("user");
//   user = JSON.parse(user);
  return {
    "Content-Type": contentType,
    "Authorization": process.env.REACT_APP_API_MGW_KEY,
  };
}

const initialState = {
  authenticated: false,
  loading: false,
  success: false,
  success_message: undefined,
  error: undefined,
  data: null, //[],
  record: null,
  records: null, //[],
}

const walkInSlice = createSlice({
  name: 'walkins',
  initialState,
  reducers: {
    errorLog: (state, action) => {
      state.loading = false;
      state.success = false;
      state.success_message = undefined;
      state.error = action.payload;
    },
    clearError: (state) => {
      state.loading = false;
      state.success = false;
      state.success_message = undefined;
      state.error = undefined;
    },
    stopLoader: (state) => {
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
    // Get all police certificate walk-in records
      .addCase(getWalkIns.pending, (state) => {
        state.loading = true;
      })
      .addCase(getWalkIns.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.success_message = undefined;
        state.records = action.payload.data.records;
        // console.log(action);
      })
      .addCase(getWalkIns.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.records = [];
        // console.log('error', action);
        state.error = action.payload.error;
      })
    // Get a walk-in record
      .addCase(getWalkInRecord.pending, (state) => {
        state.loading = true;
      })
      .addCase(getWalkInRecord.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.success_message = undefined;
        state.record = action.payload.data.record;
        // console.log(action);
      })
      .addCase(getWalkInRecord.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.record = null;
        // console.log('error', action);
        state.error = action.payload.error;
      })
    // Create walk-in record
      .addCase(createWalkIn.pending, (state) => {
        state.loading = true;
      })
      .addCase(createWalkIn.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.success_message = 'Successfully created new walk-in record.';
        state.record = action.payload.data;
        // console.log(action);
      })
      .addCase(createWalkIn.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.record = null;
        // console.log('error', action);
        state.error = action.payload.error;
      })
    // Update Walk-in Record
      .addCase(updateWalkIn.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateWalkIn.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.success_message = 'Successfully updated walk-in record.';
        state.record = action.payload.data;
        // console.log(action);
      })
      .addCase(updateWalkIn.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.record = null;
        // console.log('error', action);
        state.error = action.payload.error;
      })
    // Update Walk-in Record Payment Status Cash
      .addCase(updateWalkInPayment.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateWalkInPayment.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.success_message = 'Successfully updated payment for walk-in record.';
        state.record = action.payload.data;
        // console.log(action);
      })
      .addCase(updateWalkInPayment.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.record = null;
        // console.log('error', action);
        state.error = action.payload.error;
      })
    // Update Walk-in Record Payment Status By Card
      .addCase(updateWalkInPaymentCard.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateWalkInPaymentCard.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.success_message = 'Successfully updated payment for walk-in record.';
        state.record = action.payload.data;
        // console.log(action);
      })
      .addCase(updateWalkInPaymentCard.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.record = null;
        // console.log('error', action);
        state.error = action.payload.error;
      })
    // Attach Invoice to Walk-in Record
      .addCase(attachInvoice.pending, (state) => {
        state.loading = true;
      })
      .addCase(attachInvoice.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.success_message = 'Successfully attached invoice to walk-in record.';
        state.record = action.payload.data;
        // console.log(action);
      })
      .addCase(attachInvoice.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.record = null;
        // console.log('error', action);
        state.error = action.payload.error;
      })
  }
})

export const { clearError, stopLoader, errorLog } = walkInSlice.actions
export default walkInSlice.reducer;
 
export const getWalkIns = createAsyncThunk(
  'walkins/getWalkIns',
  async (params, { rejectWithValue }) => {
    try {
      params.start_date = format(params.start_date);
      params.end_date = format(params.end_date);
      const res = await axios.get(`${process.env.REACT_APP_API_MGW_HOST}/api/v1/police_certificates/walk_in_index`, { headers: headers(), params: params})
      // console.log(res)
      return res
    } catch (err) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue(err.response.data)
    }
  }
)

export const getWalkInRecord = createAsyncThunk(
  'walkins/getWalkInRecord',
  async (params, { rejectWithValue }) => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_MGW_HOST}/api/v1/walk_in_profiles/show_by_nib`, { headers: headers(), params: params})
      // console.log(res)
      return res
    } catch (err) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue(err.response.data)
    }
  }
)

export const createWalkIn = createAsyncThunk(
  'walkins/createWalkIn',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axios.post(`${process.env.REACT_APP_API_MGW_HOST}/api/v1/police_certificates/walk_in_create`, data, { headers: headers('multipart/form-data') })
      // console.log(res)
      return res
    } catch (err) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue(err.response.data)
    }
  }
)

export const updateWalkIn = createAsyncThunk(
  'walkins/updateWalkIn',
  async ({id, data}, { rejectWithValue }) => {
    try {
      const res = await axios.patch(`${process.env.REACT_APP_API_MGW_HOST}/api/v1/police_certificates/walk_ins/${id}`, data, { headers: headers() })
      // console.log(res)
      return res
    } catch (err) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue(err.response.data)
    }
  }
)

export const updateWalkInPayment = createAsyncThunk(
  'walkins/updateWalkInPayment',
  async (data, { rejectWithValue }) => {
    try {
      const res = await axios.put(`${process.env.REACT_APP_API_MGW_HOST}/api/v1/police_certificates/walk_in_update_payment`, data, { headers: headers() })
      // console.log(res)
      return res
    } catch (err) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue(err.response.data)
    }
  }
)

export const updateWalkInPaymentCard = createAsyncThunk(
  'walkins/updateWalkInPaymentCard',
  async (data, { rejectWithValue }) => {
    delete data['police_certificate']["publisher-name"];
    let res;

    try {
      res = await axios.get(`${process.env.REACT_APP_API_HOST}/api/v1/fetch_rsa_key`, { headers: headers() })
      console.log('Fetch RSA KEY', res)
      if (!res.data.rsa_key) return rejectWithValue({error: 'No RSA KEY Found!'})
    } catch (err) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue(err.response.data)
    }
    const { public_key, rsa_token } = res.data.rsa_key;

    data['police_certificate']["card_number"] = await encryptRsakey(public_key, data['police_certificate']["card-number"]);
    data['police_certificate']["card_cvv"] = await encryptRsakey(public_key, data['police_certificate']["card-cvv"]);
    data['police_certificate']["card_name"] = await encryptRsakey(public_key, data['police_certificate']["card-name"]);
    data['police_certificate']["card_exp"] = await encryptRsakey(public_key, data['police_certificate']["card-exp"]);
    data['police_certificate']["card_amount"] = await encryptRsakey(public_key, data['police_certificate']["card-amount"]);
    data['police_certificate']["rsa_token"] = rsa_token;

    // Trim First & Last Name & Invoice Number
    data.police_certificate.first_name = data.police_certificate.first_name?.trim()
    data.police_certificate.last_name = data.police_certificate.last_name?.trim()
    data.police_certificate.invoice_number = data.police_certificate.invoice_number?.trim()

    try {
      res = await axios.put(`${process.env.REACT_APP_API_MGW_HOST}/api/v1/police_certificates/walk_in_update_payment`, data, { headers: headers() });

      if (res.data && !res.data.error) {
        if (res.data.status === 400) {
          return rejectWithValue({error: `Transaction Failed! (${res?.data?.error})`})
        }
        return res
      } else {
        return rejectWithValue({error: `Transaction Failed! (${res.data.error})`})
      }
    } catch (err) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue(err.response.data)
    }
  }
)


export const attachInvoice = createAsyncThunk(
  'walkins/attachInvoice',
  async ({data}, { rejectWithValue }) => {
    try {
      const res = await axios.patch(`${process.env.REACT_APP_API_MGW_HOST}/api/v1/admin/attach_cashless_invoice`, data, { headers: headers() })
      // console.log(res)
      return res
    } catch (err) {
      if (!err.response) {
        throw err
      }
      return rejectWithValue(err.response.data)
    }
  }
)
